// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"649b9d51","406":"c652de2d","478":"2ba8a94f","540":"67b334bc"}[chunkId] + ".chunk.js";
};